import { Component, inject } from '@angular/core';
import { AuthService } from '@bayclubs/horizon';

@Component({
    selector: 'app-logged-user',
    templateUrl: './logged-user.component.html',
    styleUrls: ['./logged-user.component.scss'],
    standalone: false
})
export class LoggedUserComponent {

    private readonly horizonAuth = inject(AuthService);

    public isVisible(): boolean {
        return this.horizonAuth.isAuthenticated();
    }

    public userName(): string {
        return this.horizonAuth.userName() ?? '';
    }

    public onLogin(): void {
        this.horizonAuth.loginRedirect();
    }

    public onLogOut(): void {
        this.horizonAuth.logoutRedirect();
    }
}
